import React, { useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import useForm from 'react-hook-form';
import PropTypes from 'prop-types';
import api from '../../api';
/* actions */
import { editTypeOccurrences } from '../../redux/actions/typeOccurrences';
/* components */
import ErrorMsgField from '../../components/ErrorMsgField';
import AlertMsg from '../../components/AlertMsg';
import FormFooter from '../../components/FormFooter';
import FormHeader from '../../components/FormHeader';
/* form-validation */
import schema from '../../form-validation/typeOccurrence';
/* utils */
import handleChangeDefault from '../../utils/handleChangeDefault';

function Edit (props) {
  const { id } = props.match.params;
  const INITIAL_VALUES = {
    _id: id || '',
    name: '',
    description: '',
    classification: '',
    company: ''
  };
  const dispatch = useDispatch();
  const submitButton = useRef();
  const { register, handleSubmit, errors } = useForm({
    validationSchema: schema,
    reValidateMode: 'onSubmit'
  });
  const typeOccurrences = useSelector(state => state.typeOccurrences);
  const [data, setData] = useState(INITIAL_VALUES);

  useEffect(() => {
    (async function () {
      try {
        const params = { _id: id };
        const { data } = await api().get('/api/type_occurrences', { params });
        if (data[0]) {
          const newData = {
            ...INITIAL_VALUES,
            ...data[0]
          };
          setData(newData);
        }
      } catch (err) {
        console.error('Error: ', err);
      }
    })();
  }, []);

  const submit = () => {
    dispatch(editTypeOccurrences(data, submitButton.current));
  };

  return (
    <div className="container-fluid">
      {typeOccurrences.editSuccess && (
        <AlertMsg
          type="success"
          msg="Tipo de ocorrência atualizada com sucesso"
        />
      )}
      {typeOccurrences.errorContent &&
        !typeOccurrences.errorContent.message.includes('400') &&
        typeOccurrences.editError && (
        <AlertMsg
          type="danger"
          msg="Falha durante atualização do tipo de ocorrência"
        />
      )}
      {typeOccurrences.errorContent &&
        typeOccurrences.errorContent.message.includes('400') &&
        typeOccurrences.editError && (
        <AlertMsg
          type="danger"
          msg="Um tipo de ocorrência com o nome informado já está cadastrado"
        />
      )}
      {!typeOccurrences.editSuccess && !typeOccurrences.editError && (
        <AlertMsg type="info" msg="Área atualização do tipo de ocorrências" />
      )}
      <FormHeader title="Atualizar Tipo de Ocorrência" />
      <form onSubmit={handleSubmit(submit)}>
        <div className="form-group">
          <label htmlFor="name">
            Nome<span className="field-required">*</span>
          </label>
          <input
            type="text"
            className="form-control"
            id="name"
            name="name"
            autoComplete="off"
            value={data.name}
            onChange={evt => handleChangeDefault(evt, data, setData)}
            ref={register}
          />
          {errors.name && errors.name.type === 'required' && (
            <ErrorMsgField type="required" />
          )}
        </div>
        <div className="form-group">
          <label htmlFor="classification">
            Classificação<span className="field-required">*</span>
          </label>
          <select
            id="classification"
            name="classification"
            className="form-control"
            value={data.classification}
            onChange={evt => handleChangeDefault(evt, data, setData)}
            ref={register}
          >
            <option value="">-- Selecione --</option>
            <option value="L">Leve</option>
            <option value="M">Médio</option>
            <option value="S">Grave</option>
            <option value="VS">Gravíssimo</option>
          </select>
          {errors.classification &&
            errors.classification.type === 'required' && (
            <ErrorMsgField type="required" />
          )}
        </div>
        <div className="form-group">
          <label htmlFor="description">
            Descrição<span className="field-required">*</span>
          </label>
          <textarea
            className="form-control"
            id="description"
            name="description"
            rows="3"
            value={data.description}
            onChange={evt => handleChangeDefault(evt, data, setData)}
            ref={register}
          ></textarea>
          {errors.description && errors.description.type === 'required' && (
            <ErrorMsgField type="required" />
          )}
        </div>
        <FormFooter url="/type_occurrences" reference={submitButton} />
      </form>
    </div>
  );
}

Edit.propTypes = {
  match: PropTypes.object
};

export default Edit;
